(ns io.daskul.tutorial.webapp.views.login
  "Login page view with school branding."
  (:require
   [uix.core :refer [defui $ use-state]]
   [uix.re-frame :as urf]
   [re-frame.core :as rf]
   [io.daskul.tutorial.webapp.domain.auth.events :as auth.events]
   [io.daskul.tutorial.webapp.domain.auth.subs :as auth.subs]
   [io.daskul.tutorial.webapp.app.events :as app.events]
   [io.daskul.tutorial.webapp.router :as router]
   [io.daskul.webapp.auth.throttle :as throttle]
   [io.daskul.webapp.ui :as ui]))

(defui brand-panel
  "Left panel — Klei platform branding. The mark carries the brand here; the
   name is set by the wordmark over the form. Typed 'Klei' must not stand in
   for the wordmark."
  []
  ($ ui/box {:class "login-brand-panel"}
    ($ ui/stack {:gap "lg" :align "center" :justify "center"
                 :style {:height "100%" :position "relative" :z-index 1}}
      ($ :img {:src "/klei-icon.svg" :alt "Klei" :width 96 :height 96})
      ($ ui/text {:ta "center" :size "md" :fw 500 :class "login-brand-eyebrow"}
        "Education Platform")
      ($ ui/text {:ta "center" :size "sm" :maw 260
                  :class "login-brand-tagline"}
        "Modern school management, simplified."))))

(defui login-page []
  (let [[email set-email!] (use-state "")
        [password set-password!] (use-state "")
        loading? (urf/use-subscribe [::auth.subs/loading?])
        error (urf/use-subscribe [::auth.subs/error])
        retry-after (urf/use-subscribe [::auth.subs/retry-after])]
    ($ ui/box {:class "login-page"}
      ($ brand-panel)

      ($ ui/box {:class "login-form-panel"}
        ($ ui/stack {:gap "xl" :w "100%" :maw 380 :class "login-form-stack"}
          (let [school-info (urf/use-subscribe [::app.events/school-info])
                school-name (:name school-info)
                logo-url (:logo-url school-info)]
            ($ ui/stack {:gap "sm" :align "center" :class "login-identity"}
              ($ :img {:src "/klei-wordmark.svg" :alt "Klei"
                       :width 104 :height 45 :class "login-form-wordmark"})
              (when logo-url
                ($ :img {:src logo-url
                         :alt school-name
                         :class "login-tenant-logo"}))
              ($ ui/title {:order 3 :ta "center"} (or school-name "Loading..."))
              ($ ui/text {:c "dimmed" :size "sm" :ta "center"} "Sign in to your account")))

          (cond
            ;; Rate-limit lockout (SMS-280) — distinct from a wrong-password
            ;; error, with a live countdown so the user knows to wait.
            retry-after
            ($ ui/error-alert {:title "Too many attempts"}
              (throttle/countdown-message retry-after))

            error
            ($ ui/error-alert error))

          ($ :form
            {:on-submit (fn [e]
                          (.preventDefault e)
                          (let [school-code (router/get-school-code)]
                            (rf/dispatch [::auth.events/login {:email email
                                                               :password password
                                                               :school-code school-code}])))}
            ($ ui/stack {:gap "md"}
              ($ ui/text-input
                {:label "Email"
                 :placeholder "your@email.com"
                 :value email
                 :on-change #(set-email! (.. % -target -value))
                 :required true
                 :size "md"})

              ($ ui/password-input
                {:label "Password"
                 :placeholder "Your password"
                 :value password
                 :on-change #(set-password! (.. % -target -value))
                 :required true
                 :size "md"})

              ($ ui/button
                {:type "submit"
                 :fullWidth true
                 :loading loading?
                 :disabled (boolean retry-after)
                 :size "md"}
                "Sign in"))))))))
